// extracted by mini-css-extract-plugin
module.exports = {"form":"formStructure_form__3pj26"};